module.exports = __webpack_public_path__ + "img/muende_bwino_2.6bb5d7b6.jpg";